import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "exam-results-view" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "border-b border-gray-200 dark:border-gray-700" }
const _hoisted_4 = {
  class: "-mb-px flex space-x-8",
  "aria-label": "Tabs"
}
const _hoisted_5 = { class: "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 mb-4 shadow-sm" }
const _hoisted_6 = { class: "flex flex-col lg:flex-row lg:items-end gap-4" }
const _hoisted_7 = { class: "flex-1" }
const _hoisted_8 = { class: "block text-sm font-medium text-gray-900 dark:text-white mb-2" }
const _hoisted_9 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }
const _hoisted_10 = ["min", "disabled"]
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = { class: "grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 gap-2" }
const _hoisted_13 = { class: "flex items-end" }
const _hoisted_14 = {
  key: 0,
  class: "mt-3 pt-3 border-t border-gray-200 dark:border-gray-700"
}
const _hoisted_15 = { class: "flex items-center gap-2 text-sm" }
const _hoisted_16 = { class: "px-2 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-md font-medium" }
const _hoisted_17 = { class: "text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700" }
const _hoisted_20 = { class: "px-4 sm:px-6 py-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_21 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" }
const _hoisted_22 = { class: "flex items-center gap-3" }
const _hoisted_23 = { class: "px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full text-xs font-medium" }
const _hoisted_24 = { class: "w-full sm:w-64" }
const _hoisted_25 = {
  key: 0,
  class: "p-8 text-center"
}
const _hoisted_26 = {
  key: 1,
  class: "p-8 text-center"
}
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "hidden xl:block overflow-x-auto" }
const _hoisted_29 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_30 = { class: "bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_31 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_32 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_33 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_34 = { class: "px-6 py-4" }
const _hoisted_35 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_36 = {
  key: 0,
  class: "text-xs text-gray-500 dark:text-gray-400"
}
const _hoisted_37 = { class: "px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_38 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_39 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_40 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_41 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_42 = { class: "text-sm text-gray-900 dark:text-white" }
const _hoisted_43 = { class: "px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "xl:hidden divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_46 = { class: "bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm" }
const _hoisted_47 = { class: "p-4" }
const _hoisted_48 = { class: "mb-3" }
const _hoisted_49 = { class: "text-base font-semibold text-gray-900 dark:text-white mb-1" }
const _hoisted_50 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_51 = { class: "mb-3" }
const _hoisted_52 = { class: "text-sm font-medium text-gray-900 dark:text-white mb-1" }
const _hoisted_53 = {
  key: 0,
  class: "text-xs text-secondary-text dark:text-secondary-dark-text"
}
const _hoisted_54 = { class: "space-y-2 text-sm" }
const _hoisted_55 = { class: "flex justify-between items-center" }
const _hoisted_56 = { class: "text-right" }
const _hoisted_57 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_58 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text ml-1" }
const _hoisted_59 = { class: "flex justify-between items-center" }
const _hoisted_60 = { class: "flex justify-between" }
const _hoisted_61 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_62 = { class: "flex justify-end pt-3 mt-3 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 3,
  class: "px-4 sm:px-6 py-4 border-t border-gray-200 dark:border-gray-700"
}
const _hoisted_65 = { class: "flex items-center justify-between" }
const _hoisted_66 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }

import { ref, computed, onMounted, watch } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { examResultService } from '@/services/examResultService'
import type { ExamResult, ExamAttemptHistory } from '@/services/examResultService'
import BaseButton from '@/components/common/BaseButton.vue'
import { ClipboardList, Eye, Calendar, X, History, Archive } from 'lucide-vue-next'
import { useRouter } from 'vue-router'

// Page title
interface GroupedExamResult {
  key: string
  employeeId: number
  examId: number
  latestResult: ExamResult
  results: ExamResult[]
}

interface GroupedAttempt {
  key: string
  resetDate: string
  resetDateFormatted: string
  resetBy: any
  attempts: ExamAttemptHistory[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResultsView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Douglas Private Care Services')
useTitle(`Exam Results - ${appTitle.value}`)

const router = useRouter()
const loading = ref(false)
const examResults = ref<ExamResult[]>([])
const currentSearchQuery = ref('')

// Load active tab from localStorage
const loadActiveTabFromStorage = (): 'current' | 'history' => {
  try {
    const savedTab = localStorage.getItem('examResultsActiveTab')
    if (savedTab === 'current' || savedTab === 'history') {
      return savedTab
    }
  } catch (error) {
    console.error('Failed to load active tab from localStorage:', error)
  }
  return 'current'
}

// Save active tab to localStorage
const saveActiveTabToStorage = (tab: 'current' | 'history') => {
  try {
    localStorage.setItem('examResultsActiveTab', tab)
  } catch (error) {
    console.error('Failed to save active tab to localStorage:', error)
  }
}

// Tab state - initialize from localStorage
const activeTab = ref<'current' | 'history'>(loadActiveTabFromStorage())

// Watch for active tab changes and save to localStorage
watch(activeTab, (newValue) => {
  saveActiveTabToStorage(newValue)
})

// Attempt History state
const historyLoading = ref(false)
const attemptHistory = ref<ExamAttemptHistory[]>([])
const expandedGroups = ref<Set<string>>(new Set())
const historySearchQuery = ref('')

// Load date range from localStorage
const loadDateRangeFromStorage = () => {
  try {
    const savedDateRange = localStorage.getItem('examResultsDateRange')
    if (savedDateRange) {
      return JSON.parse(savedDateRange)
    }
  } catch (error) {
    console.error('Failed to load date range from localStorage:', error)
  }
  return { start: '', end: '' }
}

// Save date range to localStorage
const saveDateRangeToStorage = (range: { start: string; end: string }) => {
  try {
    localStorage.setItem('examResultsDateRange', JSON.stringify(range))
  } catch (error) {
    console.error('Failed to save date range to localStorage:', error)
  }
}

// Date range filter state - initialize from localStorage
const dateRange = ref(loadDateRangeFromStorage())

// Load active preset from localStorage
const loadActivePresetFromStorage = (): string | null => {
  try {
    const savedPreset = localStorage.getItem('examResultsActivePreset')
    return savedPreset || null
  } catch (error) {
    console.error('Failed to load active preset from localStorage:', error)
    return null
  }
}

// Save active preset to localStorage
const saveActivePresetToStorage = (preset: string | null) => {
  try {
    if (preset) {
      localStorage.setItem('examResultsActivePreset', preset)
    } else {
      localStorage.removeItem('examResultsActivePreset')
    }
  } catch (error) {
    console.error('Failed to save active preset to localStorage:', error)
  }
}

const activePreset = ref<string | null>(loadActivePresetFromStorage())

// Watch for active preset changes and save to localStorage
watch(activePreset, (newValue) => {
  saveActivePresetToStorage(newValue)
})

// Watch for date range changes and save to localStorage
watch(
  dateRange,
  (newValue) => {
    saveDateRangeToStorage(newValue)
    
    // If "To Date" is before "From Date", clear "To Date"
    if (newValue.start && newValue.end) {
      const startDate = new Date(newValue.start)
      const endDate = new Date(newValue.end)
      if (endDate < startDate) {
        dateRange.value.end = ''
      }
    }
  },
  { deep: true }
)

// Filtered and formatted exam results
const filteredExamResults = computed(() => {
  let filtered = examResults.value

  // Apply date range filter
  if (dateRange.value.start || dateRange.value.end) {
    filtered = filtered.filter(item => {
      if (!item.date_taken) return false
      
      const itemDate = new Date(item.date_taken)
      itemDate.setHours(0, 0, 0, 0)
      
      if (dateRange.value.start) {
        const startDate = new Date(dateRange.value.start)
        startDate.setHours(0, 0, 0, 0)
        if (itemDate < startDate) return false
      }
      
      if (dateRange.value.end) {
        const endDate = new Date(dateRange.value.end)
        endDate.setHours(23, 59, 59, 999)
        if (itemDate > endDate) return false
      }
      
      return true
    })
  }

  // Apply search filter
  if (currentSearchQuery.value.trim()) {
    const query = currentSearchQuery.value.toLowerCase().trim()
    filtered = filtered.filter(item => {
      const employeeName = (item.employee?.user_details?.full_name || '').toLowerCase()
      const employeeEmail = (item.employee?.email || '').toLowerCase()
      const examName = (item.exam?.exam_name || '').toLowerCase()
      const lessonName = (item.exam?.lesson?.name || '').toLowerCase()
      
      return employeeName.includes(query) || 
             employeeEmail.includes(query) || 
             examName.includes(query) || 
             lessonName.includes(query)
    })
  }

  // Map to display format
  return filtered.map(item => ({
    ...item,
    employee_name: item.employee?.user_details?.full_name || item.employee?.email || '',
    exam_name: item.exam?.exam_name || '',
    lesson_name: item.exam?.lesson?.name || '',
    remarks_label: item.remarks_label || '', 
    exam_result_id: item.exam_result_id
  }))
})

// Group current exam results by employee + exam
const groupedExamResults = computed<GroupedExamResult[]>(() => {
  const groups = new Map<string, GroupedExamResult>()
  
  filteredExamResults.value.forEach(result => {
    // Create a unique key for grouping by employee + exam
    const employeeId = result.employee?.user_id || 0
    const examId = result.exam?.exam_id || 0
    const key = `${employeeId}_${examId}`
    
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        employeeId,
        examId,
        latestResult: result,
        results: []
      })
    }
    
    const group = groups.get(key)
    if (group) {
      group.results.push(result)
      
      // Update latest result if this one is more recent
      if (new Date(result.date_taken || 0) > new Date(group.latestResult.date_taken || 0)) {
        group.latestResult = result
      }
    }
  })
  
  // Sort groups by latest date (newest first) and sort results within each group
  return Array.from(groups.values())
    .sort((a, b) => {
      const dateA = new Date(a.latestResult.date_taken || 0).getTime()
      const dateB = new Date(b.latestResult.date_taken || 0).getTime()
      return dateB - dateA
    })
    .map(group => ({
      ...group,
      results: group.results.sort((a, b) => {
        // Sort by date taken (newest first)
        const dateA = new Date(a.date_taken || 0).getTime()
        const dateB = new Date(b.date_taken || 0).getTime()
        return dateB - dateA
      })
    }))
})

// Toggle current group expansion (removed — no longer needed)
// const toggleCurrentGroup = (key: string) => {
//   if (expandedCurrentGroups.value.has(key)) {
//     expandedCurrentGroups.value.delete(key)
//   } else {
//     expandedCurrentGroups.value.add(key)
//   }
// }

// Filtered attempt history
const filteredAttemptHistory = computed(() => {
  let filtered = attemptHistory.value

  // Apply date range filter (using reset_date for history)
  if (dateRange.value.start || dateRange.value.end) {
    filtered = filtered.filter(item => {
      if (!item.reset_date) return false
      
      const itemDate = new Date(item.reset_date)
      itemDate.setHours(0, 0, 0, 0)
      
      if (dateRange.value.start) {
        const startDate = new Date(dateRange.value.start)
        startDate.setHours(0, 0, 0, 0)
        if (itemDate < startDate) return false
      }
      
      if (dateRange.value.end) {
        const endDate = new Date(dateRange.value.end)
        endDate.setHours(23, 59, 59, 999)
        if (itemDate > endDate) return false
      }
      
      return true
    })
  }

  // Apply search filter
  if (historySearchQuery.value.trim()) {
    const query = historySearchQuery.value.toLowerCase().trim()
    filtered = filtered.filter(item => {
      const employeeName = getEmployeeName(item).toLowerCase()
      const employeeEmail = getEmployeeEmail(item).toLowerCase()
      const examName = (item.exam?.exam_name || '').toLowerCase()
      const lessonName = (item.exam?.lesson?.name || '').toLowerCase()
      
      return employeeName.includes(query) || 
             employeeEmail.includes(query) || 
             examName.includes(query) || 
             lessonName.includes(query)
    })
  }

  return filtered
})

// Group attempt history by Restart Date, employee, and exam
const groupedAttemptHistory = computed<GroupedAttempt[]>(() => {
  const groups = new Map<string, GroupedAttempt>()
  
  filteredAttemptHistory.value.forEach(attempt => {
    // Create a unique key for grouping by reset_date + employee + exam
    const employeeId = attempt.employee?.user_id || 'unknown'
    const examId = attempt.exam?.exam_id || 'unknown'
    const resetDate = attempt.reset_date || 'unknown'
    const key = `${resetDate}_${employeeId}_${examId}`
    
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        resetDate: attempt.reset_date || '',
        resetDateFormatted: attempt.reset_date_formatted || '',
        resetBy: attempt.reset_by,
        attempts: []
      })
    }
    
    const group = groups.get(key)
    if (group) {
      group.attempts.push(attempt)
    }
  })
  
  // Sort groups by Restart Date (newest first) and sort attempts within each group
  return Array.from(groups.values())
    .sort((a, b) => {
      const dateA = new Date(a.resetDate).getTime()
      const dateB = new Date(b.resetDate).getTime()
      return dateB - dateA
    })
    .map(group => ({
      ...group,
      attempts: group.attempts.sort((a, b) => {
        // Sort by attempt number
        return (a.num_of_attempts || 0) - (b.num_of_attempts || 0)
      })
    }))
})

// Toggle group expansion
const toggleGroup = (key: string) => {
  if (expandedGroups.value.has(key)) {
    expandedGroups.value.delete(key)
  } else {
    expandedGroups.value.add(key)
  }
}

// Helper functions for attempt history
const getEmployeeName = (item: ExamAttemptHistory): string => {
  return item.employee?.user_details?.full_name || item.employee?.email || 'N/A'
}

const getEmployeeEmail = (item: ExamAttemptHistory): string => {
  return item.employee?.email || ''
}

// Date range preset functions
const setDateRangePreset = (preset: string) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  
  activePreset.value = preset
  
  switch (preset) {
    case 'today':
      dateRange.value.start = formatDateForInput(today)
      dateRange.value.end = formatDateForInput(today)
      break
      
    case 'week': {
      const startOfWeek = new Date(today)
      const day = startOfWeek.getDay()
      const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1) // Adjust when day is Sunday
      startOfWeek.setDate(diff)
      
      const endOfWeek = new Date(startOfWeek)
      endOfWeek.setDate(startOfWeek.getDate() + 6)
      
      dateRange.value.start = formatDateForInput(startOfWeek)
      dateRange.value.end = formatDateForInput(endOfWeek)
      break
    }
      
    case 'month': {
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
      
      dateRange.value.start = formatDateForInput(startOfMonth)
      dateRange.value.end = formatDateForInput(endOfMonth)
      break
    }
      
    case 'year': {
      const startOfYear = new Date(today.getFullYear(), 0, 1)
      const endOfYear = new Date(today.getFullYear(), 11, 31)
      
      dateRange.value.start = formatDateForInput(startOfYear)
      dateRange.value.end = formatDateForInput(endOfYear)
      break
    }
  }
}

const isPresetActive = (preset: string) => {
  return activePreset.value === preset
}

const clearDateFilter = () => {
  dateRange.value.start = ''
  dateRange.value.end = ''
  activePreset.value = null
}

const formatDateForInput = (date: Date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const formatDateRange = () => {
  if (dateRange.value.start && dateRange.value.end) {
    const start = new Date(dateRange.value.start).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    })
    const end = new Date(dateRange.value.end).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    })
    return `${start} - ${end}`
  } else if (dateRange.value.start) {
    return `From ${new Date(dateRange.value.start).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    })}`
  } else if (dateRange.value.end) {
    return `Until ${new Date(dateRange.value.end).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    })}`
  }
  return ''
}

// View exam result details
const viewExamResult = (examResultId: number) => {
  console.log('🔍 Viewing exam result with ID:', examResultId)
  console.log('📋 Available exam results IDs:', examResults.value.map(r => r.exam_result_id))
  
  // Verify the ID exists in our data
  const resultExists = examResults.value.some(r => r.exam_result_id === examResultId)
  console.log('✅ Result exists in current data:', resultExists)
  
  if (!resultExists) {
    console.error('❌ Exam result ID not found in current data:', examResultId)
    return
  }
  
  router.push({ 
    name: 'ResultsExamView', 
    params: { id: examResultId.toString() } 
  })
}

// Helper for status color
function getStatusClass(remarks: number) {
  if (remarks === 1) return 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100'
  if (remarks === 0) return 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100'
  return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100'
}

onMounted(async () => {
  loading.value = true
  historyLoading.value = true
  
  try {
    console.log('📥 Loading exam results...')
    const response = await examResultService.getAllExamResults({ 
      sort_by: 'date_taken', 
      sort_order: 'desc' 
    })
    
    // Handle both paginated and non-paginated responses
    if (Array.isArray(response.data)) {
      examResults.value = response.data
    } else {
      examResults.value = response.data.data || []
    }
    
    console.log('✅ Loaded exam results:', examResults.value.length)
    console.log('📊 Exam results data:', examResults.value)
    
  } catch (err) {
    console.error('❌ Failed to load exam results:', err)
    examResults.value = []
  } finally {
    loading.value = false
  }

  // Load attempt history
  try {
    console.log('📥 Loading attempt history...')
    
    // Note: For now, we'll fetch all attempt history
    // You may want to implement per-employee filtering or pagination
    const historyResponse = await examResultService.getAllAttemptHistory({
      sort_by: 'reset_date',
      sort_order: 'desc'
    })
    
    attemptHistory.value = historyResponse.data || []
    
    console.log('✅ Loaded attempt history:', attemptHistory.value.length)
    console.log('📊 Attempt history data:', attemptHistory.value)
    
  } catch (err) {
    console.error('❌ Failed to load attempt history:', err)
    attemptHistory.value = []
  } finally {
    historyLoading.value = false
  }
})

// Ensure scores are displayed as whole numbers and calculate safe percentages
const formatScore = (score?: number | null) => {
  const n = Number(score ?? 0)
  if (Number.isNaN(n)) return 0
  return Math.round(n)
}

const calculatePercentage = (user?: number | null, total?: number | null) => {
  const u = Number(user ?? 0)
  const t = Number(total ?? 0)
  if (Number.isNaN(u) || Number.isNaN(t) || t <= 0) return 0
  const pct = Math.round((u / t) * 100)
  return Math.min(100, Math.max(0, pct))
}

const formatPercentage = (user?: number | null, total?: number | null) => {
  return calculatePercentage(user, total)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mb-6" }, [
      _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-2" }, " Exam Results "),
      _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " Review an employee's most recent exam results. ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'current')),
            class: _normalizeClass([
              activeTab.value === 'current'
                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300',
              'group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200'
            ])
          }, [
            _createVNode(_unref(ClipboardList), {
              class: _normalizeClass([
                activeTab.value === 'current' ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500',
                '-ml-0.5 mr-2 h-5 w-5'
              ])
            }, null, 8, ["class"]),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Current Results", -1)),
            (filteredExamResults.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass([
                activeTab.value === 'current'
                  ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400'
                  : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
                'ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium'
              ])
                }, _toDisplayString(filteredExamResults.value.length), 3))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _createVNode(_unref(Calendar), { class: "w-4 h-4 inline-block mr-1" }),
            _cache[9] || (_cache[9] = _createTextVNode(" Filter by Date Range ", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block text-xs text-secondary-text dark:text-secondary-dark-text mb-1" }, " From Date ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateRange.value.start) = $event)),
                type: "date",
                class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 text-sm",
                placeholder: "Start date"
              }, null, 512), [
                [_vModelText, dateRange.value.start]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-xs text-secondary-text dark:text-secondary-dark-text mb-1" }, " To Date ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateRange.value.end) = $event)),
                type: "date",
                min: dateRange.value.start,
                disabled: !dateRange.value.start,
                class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 text-sm disabled:opacity-50 disabled:cursor-not-allowed",
                placeholder: "End date"
              }, null, 8, _hoisted_10), [
                [_vModelText, dateRange.value.end]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-900 dark:text-white mb-2" }, " Quick Filters ", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (setDateRangePreset('today'))),
              class: _normalizeClass([
                'px-3 py-2 rounded-lg text-xs font-medium transition-all duration-200',
                isPresetActive('today')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              ])
            }, " Today ", 2),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (setDateRangePreset('week'))),
              class: _normalizeClass([
                'px-3 py-2 rounded-lg text-xs font-medium transition-all duration-200',
                isPresetActive('week')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              ])
            }, " This Week ", 2),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (setDateRangePreset('month'))),
              class: _normalizeClass([
                'px-3 py-2 rounded-lg text-xs font-medium transition-all duration-200',
                isPresetActive('month')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              ])
            }, " This Month ", 2),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (setDateRangePreset('year'))),
              class: _normalizeClass([
                'px-3 py-2 rounded-lg text-xs font-medium transition-all duration-200',
                isPresetActive('year')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              ])
            }, " This Year ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(BaseButton, {
            text: "Clear",
            variant: "danger",
            size: "sm",
            icon: _unref(X),
            disabled: !dateRange.value.start && !dateRange.value.end,
            onClick: clearDateFilter
          }, null, 8, ["icon", "disabled"])
        ])
      ]),
      (dateRange.value.start || dateRange.value.end)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Active Filter:", -1)),
              _createElementVNode("span", _hoisted_16, _toDisplayString(formatDateRange()), 1),
              _createElementVNode("span", _hoisted_17, " (" + _toDisplayString(filteredExamResults.value.length) + " results) ", 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (activeTab.value === 'current')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(ClipboardList), { class: "w-5 h-5 text-blue-500" }),
                  _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900 dark:text-white" }, " Current Results ", -1)),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(groupedExamResults.value.length) + " group" + _toDisplayString(groupedExamResults.value.length !== 1 ? 's' : ''), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentSearchQuery).value = $event)),
                    type: "text",
                    placeholder: "Search by employee or exam...",
                    class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 text-sm"
                  }, null, 512), [
                    [_vModelText, currentSearchQuery.value]
                  ])
                ])
              ])
            ]),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" }, null, -1),
                  _createElementVNode("p", { class: "mt-2 text-sm text-secondary-text dark:text-secondary-dark-text" }, "Loading exam results...", -1)
                ]))]))
              : (groupedExamResults.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_unref(ClipboardList), { class: "w-12 h-12 mx-auto text-gray-400 mb-3" }),
                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "No exam results found.", -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("table", _hoisted_29, [
                        _cache[17] || (_cache[17] = _createElementVNode("thead", { class: "bg-gray-50 dark:bg-gray-900" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Employee "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Exam "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Score "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Status "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Date Taken "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "w-16 px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Action ")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedExamResults.value, (group) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: group.key,
                              class: "hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                            }, [
                              _createElementVNode("td", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, _toDisplayString(group.latestResult.employee?.user_details?.full_name || group.latestResult.employee?.email || 'N/A'), 1),
                                _createElementVNode("div", _hoisted_33, _toDisplayString(group.latestResult.employee?.email), 1)
                              ]),
                              _createElementVNode("td", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, _toDisplayString(group.latestResult.exam?.exam_name || 'N/A'), 1),
                                (group.latestResult.exam?.lesson)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(group.latestResult.exam.lesson.name), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, _toDisplayString(formatScore(group.latestResult.user_score)) + "/" + _toDisplayString(formatScore(group.latestResult.total_score)), 1),
                                _createElementVNode("div", _hoisted_39, _toDisplayString(formatPercentage(group.latestResult.user_score, group.latestResult.total_score)) + "% ", 1)
                              ]),
                              _createElementVNode("td", _hoisted_40, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([
                        'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                        getStatusClass(group.latestResult.remarks)
                      ])
                                }, _toDisplayString(group.latestResult.remarks_label), 3)
                              ]),
                              _createElementVNode("td", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, _toDisplayString(group.latestResult.date_taken_formatted), 1)
                              ]),
                              _createElementVNode("td", _hoisted_43, [
                                _createElementVNode("button", {
                                  onClick: _withModifiers(($event: any) => (viewExamResult(group.latestResult.exam_result_id)), ["stop"]),
                                  class: "p-2 rounded-lg text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors",
                                  title: "View Details"
                                }, [
                                  _createVNode(_unref(Eye), { class: "h-5 w-5" })
                                ], 8, _hoisted_44)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedExamResults.value, (group) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: group.key,
                          class: "p-4"
                        }, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("h3", _hoisted_49, _toDisplayString(group.latestResult.employee?.user_details?.full_name || group.latestResult.employee?.email || 'N/A'), 1),
                                _createElementVNode("p", _hoisted_50, _toDisplayString(group.latestResult.employee?.email), 1)
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, _toDisplayString(group.latestResult.exam?.exam_name || 'N/A'), 1),
                                (group.latestResult.exam?.lesson)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, " Lesson: " + _toDisplayString(group.latestResult.exam.lesson.name), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Score:", -1)),
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("span", _hoisted_57, _toDisplayString(formatScore(group.latestResult.user_score)) + "/" + _toDisplayString(formatScore(group.latestResult.total_score)), 1),
                                    _createElementVNode("span", _hoisted_58, " (" + _toDisplayString(formatPercentage(group.latestResult.user_score, group.latestResult.total_score)) + "%) ", 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Status:", -1)),
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                          getStatusClass(group.latestResult.remarks)
                        ])
                                  }, _toDisplayString(group.latestResult.remarks_label), 3)
                                ]),
                                _createElementVNode("div", _hoisted_60, [
                                  _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Date Taken:", -1)),
                                  _createElementVNode("span", _hoisted_61, _toDisplayString(group.latestResult.date_taken_formatted), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (viewExamResult(group.latestResult.exam_result_id)),
                                  class: "p-2 rounded-lg text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors",
                                  title: "View Details"
                                }, [
                                  _createVNode(_unref(Eye), { class: "h-5 w-5" })
                                ], 8, _hoisted_63)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])),
            (groupedExamResults.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, " Showing " + _toDisplayString(groupedExamResults.value.length) + " exam result" + _toDisplayString(groupedExamResults.value.length !== 1 ? 's' : ''), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})